<template>
  <div class="login-first-show-modal">
    <b-button id="show-btn" @click="$bvModal.show('myModal')"
      >Open Modal</b-button
    >
    <b-modal id="myModal" centered hide-footer hide-header>
      <div class="container">
        <h1 class="main-title">Congrats! It's your first login.</h1>
        <h2>Please confirm your information and update your password.</h2>
        <button class="btn btn-blue" type="submit">Confirm your info</button>
        <b-button class="cancel" @click="$bvModal.hide('myModal')"
          >I'll do later</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "LoginFirstShowModal",
  data() {
    return { open: false };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";

.modal-content {
  .container {
    align-items: center;
    display: flex;
    flex-direction: column;
    /* stylelint-disable-next-line declaration-no-important */
    font-family: "Poppins", sans-serif !important;
    padding: 2rem 1rem;

    .main-title {
      color: $black;
    }

    h2 {
      font-size: 1em;
      text-align: center;
      color: $gray;
      font-weight: 400;
    }

    button {
      margin-top: 2rem;
      margin-bottom: 1rem;
    }
    .cancel {
      font-family: "Poppins", sans-serif !important;
      margin-top: 0;
      background: none;
      padding: 0;
      margin: 0;
      font-size: 0.85em;
      color: $gray;
      font-weight: 500;
      transition: all 0.4s ease-in-out;
      border: none;

      &:hover,
      &:focus {
        color: $gray;
        background: none;
        opacity: 0.8;
        text-decoration: none;
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  .modal-content {
    .container {
      padding: 2rem 1rem;

      .main-title {
        font-size: 1.5em;
      }
    }
  }
}
</style>
